import type { AdminAccess } from "@/features/admin/useAdminAccess"

export type AssociationsModerationNavGate = {
  ready: boolean
  hasSubtreeModerationAccess: boolean
}

export const emptyAssociationsModerationNavGate = (): AssociationsModerationNavGate => ({
  ready: false,
  hasSubtreeModerationAccess: false,
})

/** Расширяет policy-based доступ правами модератора поддерева союза (без глобальных ABP-политик). */
export const mergeSubtreeModeratorAdminAccess = (
  base: AdminAccess,
  gate: AssociationsModerationNavGate,
): AdminAccess => {
  if (!gate.ready || !gate.hasSubtreeModerationAccess) return base
  return {
    ...base,
    canListUnverifiedAssociations: true,
    canVerifyAssociations: true,
    hasAnyAdminAccess: true,
  }
}
